import { createFileRoute } from '@tanstack/react-router';

import { PartnerSettings } from '~/components/Settings/PartnerSettings';
import { currentPartnerQueryOptions } from '~/services/partner';

export const Route = createFileRoute('/_authed/settings')({
  loader: async ctx => {
    await ctx.context.queryClient.ensureQueryData(
      currentPartnerQueryOptions(ctx.context.isAuthenticated),
    );
    return null;
  },
  component: PartnerSettings,
});
